import { Component, OnInit, EventEmitter, Output ,Pipe, PipeTransform, ViewChild, ElementRef, TemplateRef} from '@angular/core';
import { DocumentService } from '../../services/coreService/document.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Subscription, Observable } from 'rxjs';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { GetDocumentDetails } from 'src/app/viewModels/core/delete-document-req-vm';
import { DomSanitizer, SafeUrl, SafeResourceUrl  } from '@angular/platform-browser';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { map, startWith } from 'rxjs/operators';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { MatChipInputEvent } from '@angular/material/chips';
import { Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContactsService } from '../../services/coreService/contacts.service';
import { AddTouchesComponent } from 'src/app/middleware/common/addtouches/addtouches.component';
import { ModuleName } from '../../services/coreService/contact.enum';
import heic2any from "heic2any";
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
declare var require: any;
const FileSaver = require('file-saver');
@Component({
  selector: 'app-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.scss']
})

export class DocumentViewerComponent implements OnInit {
  @Input() folderID :number=0;  
  documentdetails= new GetDocumentDetails();
  viewer = 'google';
  organizationId: string;
  OfficeIDList: any=[];
  myOfficeID: any;
  databaseId: string;
  currentUser: any;

  showDetail:boolean = false;
  CloseViewDocument:boolean = false;
  addNote:boolean = false;
  
  clickEventsubscriptionContactDocViewer: Subscription;
  
  documentModel = {
    placeholderID:0,
    userID: '',
    documentID:0,  
    databaseID: 0,
    organizationID: 0,
    type:0
  };
  updatedocumentModel = {
    placeholderID:0,
    userID: '',
    documentID:0,  
    databaseID: 0,
    organizationID: 0,
    description: '',
    tagIdList:[],
    newTags:'',
    type:0
  };

  newTagsValues: string;
  responseHolder: any;
  myFormGroup: FormGroup; 
  documentId:number;
  DocumentShow:boolean;
  documentData:any;
  tagCtrl = new FormControl();
  filteredTags: Observable<string[]>;

  newtag: string[] = [];
  tags: string[] = [];
  allTags: string[] = [];
  AllTagList: any;
  selectedtagsId: any = [];

  newtags:string[]=[];
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA]; 
  @ViewChild('tagInput') tagInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  
  @Output() getCloseDocumentViewer = new EventEmitter<boolean>();

  getTagListResponseHolder: any;
  getTagListModel = {
    tagName: "",
    fieldID: 0,
    databaseID: 0,
    organizationID: 0,    
    PageSize:0
  };
 
  myTouchesForm: FormGroup;
  TouchesType :any[]=[];
  AllContactTouchesList  :any[]=[];
  folderList: any[] = [];
  modulename:string;
  folderId:number=0;
  transactionID: string;

  AllCoreTouchesList  :any[]=[];
  documentID :number;
  documentType: any;
  fileSize: string="";
  documentName: string="";
  createdOn:any;
  documentpath: SafeResourceUrl;
  placeholderID:number=0;
  selectedImagetoShow: any;
  
  constructor(
    private contactsService: ContactsService, private dialog: MatDialog,
    private documentService: DocumentService, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private _dataSharingService: DataSharingService,
    private statusConst: StatusConstant, public sanitizer: DomSanitizer,
    private formBuilder: FormBuilder, private toastr: ToastrService,
    private settingsService: SettingService,private loaderService: LoaderService) { 
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)	
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);
    this.currentUser = jwt_decode(token);
    this.documentdetails= new GetDocumentDetails();
   
    this.filteredTags = this.tagCtrl.valueChanges.pipe(startWith(null),
      map((fruit: string | null) => fruit ? this._filter(fruit) : this.allTags.slice()));
  }

  ngOnDestroy() {
    this.clickEventsubscriptionContactDocViewer.unsubscribe()
 }

  ngOnInit(): void {
    this.AllCoreTouchesList =[];
    this.DocumentShow=false;
    this.documentpath=null;
    this.clickEventsubscriptionContactDocViewer = this._dataSharingService.getSelectedDocumentForContact().subscribe((result) => {
      if (result) {
        this.documentName="";
        this.documentType="";
        this.fileSize="";
        this.createdOn="";     
        var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
        var Module=[];
        Module = menuModulesList.filter(x => x.mainModuleName == ModuleName.Contact);
        if(Module.length>0){    
        this.folderId = Module[0].folderID;
        }
        this.placeholderID = Object.values(result)[1];
        this.documentID= Object.values(result)[2];
        this.getAllTagsList(result); 
        this.getDocumentDetails(result);
      }      
    });
    this.transactionID = sessionStorage.getItem('transactionID');   
    this.createForm(); 
  }
  b64toBlob(b64Data, contentType='', sliceSize=512){
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
  
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
  
    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }
   blobToBase64 = blob => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise(resolve => {
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
  };
  getHEICFile(fileName:any,url:any) {
    this.documentService.getAttachment(fileName,url).subscribe((response) => {
      if (response !== undefined) {
        const data = 'data:' + response.data.contentType + ';base64,' + response.data.base64URL;
        let blobfile=this.b64toBlob(response.data.base64URL,response.data.contentType);
       (heic2any({
            blob:blobfile,
            toType:"image/jpeg",
            quality: 0.5
          })).then((conversionResult) => {
              this.blobToBase64(conversionResult).then(res => {               
                this.loaderService.hide();
                this.selectedImagetoShow=res;
              });
            });
      }else{
        this.toastr.error('File download failed.', '', {
          timeOut: 3000,
        });
      }
    });
  }
  onTabClick(event) {
    if(event.tab.textLabel=="Activity" || event.index==1){
      this.AllCoreTouchesList = [];
      this.GetAllContactTouchesList();
    }    
  }

  getDocumentDetails(result) {
    this.selectedImagetoShow='';
    this.loaderService.show();
    this.documentData=null;
    this.documentpath=""; 
    this.documentModel.userID = this.currentUser.UID;
    this.documentModel.placeholderID = result.placeholderID;
    this.documentModel.documentID = result.documentFolderID;
    this.documentModel.databaseID = Number(this.databaseId);
    this.documentModel.organizationID = Number(this.organizationId);
    this.documentModel.type = 2; // 1 FOR CORE, 2 FOR CONTACT, 3 COMPANY      
    this.documentService.getDocumentsDetailByDocumentId(this.documentModel).subscribe((response) => {
        if (response != undefined) {         
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.documentdetails = response.data.documentDeatilModel;
             if(this.documentdetails==null || this.documentdetails==undefined){
               return;
              }

              if (this.documentdetails?.uploadedByFirstName != null) {
                this.documentdetails.uploadedByFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, this.documentdetails.uploadedByFirstName);
              }
              if (this.documentdetails?.uploadedByLastName != null) {
                this.documentdetails.uploadedByLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,this.documentdetails.uploadedByLastName);
              } 

              if(response.data.documentDeatilModel.documentType!='' && response.data.documentDeatilModel.documentType!=undefined)
              {
                response.data.documentDeatilModel.documentType=response.data.documentDeatilModel.documentType.toLowerCase();
              }
              if(response.data.documentDeatilModel.documentType=='heic')
              {
                this.getHEICFile(response.data.documentDeatilModel.documentName,response.data.documentDeatilModel.documentPath);
              }
              else
              {
                this.loaderService.hide();
              }
              this.documentID = this.documentdetails.documentID;
              var uploadHistory=[];
              uploadHistory = this.responseHolder.data.uploadHistory;
              if(uploadHistory.length>0){               
                var lastElement=[];
                lastElement = uploadHistory.slice(-1);
                if(lastElement.length>0){
                  this.documentID= lastElement[0].documentID;
                 }
               }

              //this.GetAllContactTouchesList();
              //this.placeholderID = this.documentdetails.placeholderID;
  
              if(result.Fromdetail==true){
                this.documentName =result.documentName;
                this.documentType=result.fileType;
                this.fileSize = result.fileSize;
                this.createdOn = result.createdOn;
                this.documentpath=result.documentPath
              }else{
                this.documentName = this.documentdetails.documentName;
                this.documentType=this.documentdetails.documentType;
                this.fileSize = this.documentdetails.fileSize;
                this.createdOn = this.documentdetails.createdOn;
                this.documentpath=this.documentdetails.documentPath;
              }            
             
            if (response.data.tagIdList.length > 0 && response.data.tagIdList.length != undefined) {
              this.tags = [];    
             
              var drpId = response.data.tagIdList;//.split(',');
    
              for (let i = 0; i < drpId.length; i++) {
                var id = drpId[i];
                var value = this.AllTagList.filter((s) => s.tagID == parseInt(id));
                this.tags.push(value[0].tagName);
              }
            }
            else {
              this.tags = [];
            }                                          
          }
        } else {
        }
      });
  }

  
  add(event: MatChipInputEvent): void {
    this.myFormGroup.markAsDirty();	
    this.myFormGroup.markAsTouched();
    
    const input = event.input;
    const value = event.value.toLowerCase();
 
    // Add our tag
    if ((value || '').trim()) {
      this.newtag.push(event.value.trim());
      var arrToUp = String.prototype.toLowerCase.apply(this.tags).split(",");
      const index = arrToUp.indexOf(value.trim());

      if (index >= 0) {
        //this.tags.splice(index, 1);
      }
      else {
        this.tags.push(event.value.trim());
      }
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.tagCtrl.setValue(null);
  }

  remove(tag: string): void {
    const index = this.tags.indexOf(tag);
    if (index >= 0) {
      this.tags.splice(index, 1);

      if (this.tags.length > 0) {
        this.selectedtagsId = [];
        var fieldListdrp = [];
        var value;
        for (let i = 0; i < this.tags.length; i++) {
          var drpValue = this.tags[i];
          var value = this.AllTagList.filter((s) => s.tagName == drpValue);
          var newValue = value[0].tagID;
          var tagId = {
            tagID: newValue,            
          };
          fieldListdrp.push(tagId);
        }
        this.selectedtagsId = fieldListdrp;
      } 
      if (this.tags.length == 0) {
        this.selectedtagsId = this.tags;
      }
          
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.myFormGroup.markAsDirty();	
    this.myFormGroup.markAsTouched();

    const index = this.tags.indexOf(event.option.viewValue);
    if (index >= 0) {
      this.tagInput.nativeElement.value = '';
    }
    else {
      this.tags.push(event.option.viewValue);
      this.tagInput.nativeElement.value = '';
      this.tagCtrl.setValue(null);
      if (this.tags.length > 0) {
        this.selectedtagsId = [];
        var fieldListdrp = [];
        var value;
        for (let i = 0; i < this.tags.length; i++) {
          var drpValue = this.tags[i];
          var value = this.AllTagList.filter((s) => s.tagName == drpValue);
          var newValue = value[0].tagID;
          var tagId = {
            tagID: newValue,            
          };
          fieldListdrp.push(tagId);
        }
        this.selectedtagsId = fieldListdrp;
      }     
    }
  }


  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allTags.filter(tag => tag.toLowerCase().indexOf(filterValue) === 0);
  }

  createForm() {
    this.myFormGroup = this.formBuilder.group({
      description: ['',]     
    });
  }

  editTouch(touch:any){
    const dialogRef = this.dialog.open(AddTouchesComponent, {     
      data: {
        moduleName:ModuleName.Contact,
        folderID:1,//this.folderId, {{Main=1;Item=2;}}
        documentID: null,
        touch:touch
      },
       panelClass: 'autoFill-modalbox'  
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=null && result!=undefined){
        this.GetAllContactTouchesList();
      }      
    });
  }
 

  deleteTouch(touch:any){
    const message = `Are you sure you want to delete this activity ?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {      
           let model={
            "touchesID": [
              touch.touchID
            ],
              transactionID:Number(sessionStorage.getItem('transactionID')),
              databaseId:Number(this.databaseId),
              organizationID:Number(this.organizationId),
              userID:this.currentUser.UID,
              officeID: this.myOfficeID
          }
          this.contactsService.DeleteContactTouch(model).subscribe(response => {
            if (response != undefined) {
              if (response.status == this.statusConst.statusSuccess) { 
                this.GetAllContactTouchesList();
                this.toastr.success("Deleted successfully.", '', {
                  timeOut: 3000,
                });  
              }
              else {
               
              }
            }
          });
        }
      } catch (e) {
        //Observable.throw(e);
      }
    });     
  }
  
  // get Tag List
  getAllTagsList(result) {
    this.allTags=[];
    this.getTagListModel.databaseID = Number(this.databaseId);
    this.getTagListModel.organizationID = Number(this.organizationId);
    this.getTagListModel.tagName = '';    
    this.getTagListModel.PageSize = 0;
    this.settingsService.getAllTagsList(this.getTagListModel).subscribe(response => {  
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {          
          this.AllTagList = this.getTagListResponseHolder.data.tagListWithId;//tagNames;          
          if (this.AllTagList.length > 0) {
            for (let i = 0; i < this.AllTagList.length; i++) {
              var value = this.AllTagList[i].tagName;
              this.allTags.push(value);
            }            
          }else{           
          }
        }
        else {         
        }
      }
    });
  }

  getReadableFileSizeString(fileSizeInBytes) {
    var i = -1;
    var byteUnits = [' KB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
        fileSizeInBytes = fileSizeInBytes / 1024;
        i++;
    } while (fileSizeInBytes > 1024);

    return Math.max(fileSizeInBytes).toFixed(3) + byteUnits[i];
  };
  

  spinner:boolean=false;

  async UpdateDocumentDetails(data){
    this.spinner=true;
    this.myFormGroup.markAsPristine();
    this.selectedtagsId=[];
    for (let i = 0; i < this.tags.length; i++) {
      var value = this.AllTagList.filter((s) => s.tagName == this.tags[i]);
      if(value.length>0)
        this.selectedtagsId.push({
          tagID: value[0].tagID           
        });
    }
    this.updatedocumentModel.placeholderID = this.placeholderID;
    this.updatedocumentModel.documentID = this.documentID;//this.documentId;
    this.updatedocumentModel.userID = this.currentUser.UID;
    this.updatedocumentModel.description = data.description;   
    this.updatedocumentModel.databaseID = Number(this.databaseId);
    this.updatedocumentModel.organizationID = Number(this.organizationId);
    this.updatedocumentModel.tagIdList = this.selectedtagsId;
    this.updatedocumentModel.type = 2 ; //2 for Contact
    if (this.newtag.length > 0){
      this.updatedocumentModel.newTags = this.newtag.join(',');//this.tags;
    }
    else{
      this.updatedocumentModel.newTags = "";
    }   
    const result = await this.documentService.UpdateDocumentsDetailByDocumentId(this.updatedocumentModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) { 
      this.spinner=false;   
      this.toastr.success("Document update successfully.", '', {
        timeOut: 3000,
      });
      this.newtag=[];
      this.CloseDocumentViewer(false);      
    }
    else { 
      this.spinner=false;
      this.CloseDocumentViewer(false);      
    }
    
  }

  opendocdetail(){
    this.showDetail = !this.showDetail
  }

  CloseDocumentViewer(message:boolean){
    this.tags = [];
    this.tagInput.nativeElement.value = ''; 
    this.myFormGroup.reset();
    this.documentpath=null;
    this.getCloseDocumentViewer.emit(message);
    this._dataSharingService.sendSelectedDocumentForContact(null);
  }

  
  
  
  // get touch type ==//
 getTouchTypeList() {
  var ReqModel={
    databaseId:Number(this.databaseId),
    organizationID:Number(this.organizationId) 
   }
   this.settingsService.getAllTouchTypeList(ReqModel).subscribe(response => {
     if (response != undefined) {
       this.getTagListResponseHolder = response;
       if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {          
         this.TouchesType = this.getTagListResponseHolder.data;
       }
       else {
           this.TouchesType=[];
       }
     }
   });
 }

 // get Activity List
 GetAllContactTouchesList() {
  var ReqModel={
    folderID:this.folderId,
    transactionID:Number(sessionStorage.getItem('transactionID')),
    documentID:this.documentID,//null,
    placeholderID: this.placeholderID,
    databaseId:Number(this.databaseId),
    organizationID:Number(this.organizationId),
    officeID: this.myOfficeID,
    OfficeIDList:this.OfficeIDList,
    userID:this.currentUser.UID
  }
   this.contactsService.GetAllContactTouches(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.getTagListResponseHolder = response;
      if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {        
        this.getTagListResponseHolder = response.data;
        if(this.getTagListResponseHolder !=null){
          this.getTagListResponseHolder.map((res) => {
            if (res.createdByLastName != null) {
              res.createdByFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.createdByFirstName);
            }
            if (res.createdByLastName != null) {
              res.createdByLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.createdByLastName);
            }
            return res;
          });  
        }         
        this.AllCoreTouchesList = this.getTagListResponseHolder;                
      }
      else {
       
      }
    }
  });
}


 
addTouch() {
  const dialogRef = this.dialog.open(AddTouchesComponent, {     
    data: {
      moduleName: ModuleName.Contact,
      folderID:2,//this.folderId, {{Main=1;Item=2;}}
      documentID: this.documentID,
      placeholderID: this.placeholderID
    },
     panelClass: 'autoFill-modalbox'  
  });
  dialogRef.afterClosed().subscribe(result => {
    if(result!=null && result!=undefined){   
     this.GetAllContactTouchesList();
     }
   });   
 }

  
  close() {  
    this.dialog.closeAll();
  }
  DownloadFile() {
    this.loaderService.show();
    var ReqModel = {
      transactionID: Number(sessionStorage.getItem("transactionID")),
      placeholderID: this.documentModel.placeholderID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.documentService.DownloadDocument(ReqModel).subscribe((response) => {
      if (response != undefined && response.base64URL != null && response.base64URL != undefined) {
        const data = 'data:' + response.contentType + ';base64,' + response.base64URL;
        FileSaver.saveAs(data, response.name);
        this.loaderService.hide();
      } else {
        this.toastr.error('File download failed.', '', {
          timeOut: 3000,
        });
        this.loaderService.hide();
      }
    });
  } 

}
